import { render, staticRenderFns } from "./broInformations.vue?vue&type=template&id=6abf4a8c"
import script from "./broInformations.vue?vue&type=script&lang=js"
export * from "./broInformations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports